const safeStringify = (value) => {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

const toErrorRecord = (error) => {
  if (error instanceof Error) {
    return {
      name: error.name || 'Error',
      message: error.message || 'Unknown error',
      stack: error.stack || '',
    };
  }

  return {
    name: 'NonErrorValue',
    message: typeof error === 'string' ? error : safeStringify(error),
    stack: '',
  };
};

export const logClientError = (error, context = {}) => {
  const payload = {
    timestamp: new Date().toISOString(),
    context,
    error: toErrorRecord(error),
  };

  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(`[ClientError] ${payload.error.message}`, payload);
  }

  return payload;
};
